import { acceptPhoneValue } from '../../field-viewer/shared-normalizers';
export const ecomPhoneViewer = {
    normalizeLoadedValue: acceptPhoneValue
};

//# sourceMappingURL=definition-viewer.js.map